import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import SingleValueList from "~/componentes/SingleValueList";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";
import api from "~/services/api";

import { Container } from "./styles";

function RecursosList({ defaultData, setter }) {
  const [recursos, setRecursos] = useState([]);
  const [recurso, setRecurso] = useState();
  const [dfSelected, setDfSelected] = useState([]);
  const [dfAvailable, setDfAvailable] = useState([]);
  const [upgradeSetter, setUpgradeSetter] = useState(false);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/recursos", { params: { ativo: 1 } }).then((r) => setRecursos(r?.data));
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      setDfSelected((prev) => {
        const newData =
          defaultData.filter((e) => !prev?.find((p) => p?.id === e?.id)) || [];

        return [...prev, ...newData];
      });

      if (edit) {
        setter((prev) => {
          const newData =
            defaultData.filter((e) => !prev?.find((p) => p?.id === e?.id)) || [];

          return [...prev, ...newData];
        });
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    const newData = recursos.filter((e) => !dfSelected?.find((p) => p?.id === e?.id)) || [];

    setDfAvailable(newData);
  }, [dfSelected, recursos]);

  useEffect(() => {
    if (dfAvailable.length > 0) {
      setRecurso(dfAvailable[0]);
    }

  }, [dfAvailable]);

  useEffect(() => {
    if (upgradeSetter === true) {
      setUpgradeSetter(false);
      setter(dfSelected);
    }
  }, [dfSelected, upgradeSetter, setter]);

  function handleAddRecurso() {
    if (recurso?.id) {
      const checkRecurso = dfSelected?.find((e) => e?.id === recurso?.id);

      if (!checkRecurso) {
        setDfSelected((prev) => [...prev, recurso]);
        setUpgradeSetter(true);
      }
    }
  }

  function handleRemoveRecurso(data) {
    setDfSelected((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.id === data?.id);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
    setUpgradeSetter(true);
  }

  return (
    <Container>
      <Label className="titulo" title="Recursos" />
      {!(editShow && edit) && (
        <div className="Etapa_div_addRecursos">
          <Select
            list={{ list: dfAvailable, value: "id", label: "titulo" }}
            setList={setRecurso}
            defaultValue={recurso?.id}
          />
          <ColoredButton small blueLayout type="button" onClick={handleAddRecurso}>
            Adicionar
          </ColoredButton>
        </div>
      )}
      <SingleValueList
        data={dfSelected}
        dataKey="titulo"
        {...{ ...(editShow && edit ? {} : { materialIcon: "close" }) }}
        iconClick={handleRemoveRecurso}
      />
    </Container>
  );
}

export default RecursosList;
